import { API_URI } from 'src/app/_services/apiUrl';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-safety-recommendations',
  templateUrl: './safety-recommendations.component.html',
  styleUrls: ['./safety-recommendations.component.scss']
})
export class SafetyRecommendationsComponent implements OnInit {
  API_URI = API_URI;
  constructor() { }

  ngOnInit() {
  }

}
